module.exports = __webpack_public_path__ + "static/media/arrow.e0064ac6.svg";